



































import Vue from 'vue';
import DvFilterPopover from '@/components/util/DvFilterPopover.vue';
import { SkillDurationType, SkillTargetType } from '@/models/skills/SkillEnums';
import { durationTypeName, targetTypeName } from '@/helpers/SkillEnumNames';

interface IEntry {
    id: number;
    label: string;
}

//  Enumerated explicitly rather than by iterating the enum object: a numeric
//  TS enum's Object.keys yields both the names and the reverse-mapped values.
const DURATIONS: IEntry[] = [
    SkillDurationType.INSTANT,
    SkillDurationType.BUFF,
    SkillDurationType.DEBUFF,
    SkillDurationType.TIMED_TOGGLE,
    SkillDurationType.ACTIVE_TOGGLE,
    SkillDurationType.AURA,
    SkillDurationType.ACTIVE_TOGGLE_PET,
    SkillDurationType.SUMMON_DESUMMON_PET,
    SkillDurationType.CHANGE_STANCE,
    SkillDurationType.UNIFIED_SKILL,
].map((id) => ({ id, label: durationTypeName(id) }));

const TARGETS: IEntry[] = [
    SkillTargetType.SELF,
    SkillTargetType.ENEMY,
    SkillTargetType.ALLIED,
    SkillTargetType.PARTY_MEMBERS,
    SkillTargetType.ALL,
].map((id) => ({ id, label: targetTypeName(id) }));

export default Vue.extend({
    components: { DvFilterPopover },
    props: {
        durations: { type: Array as () => number[], default: () => [] },
        targets: { type: Array as () => number[], default: () => [] },
    },
    computed: {
        durationEntries(): IEntry[] {
            return DURATIONS;
        },
        targetEntries(): IEntry[] {
            return TARGETS;
        },
    },
    methods: {
        toggle(event: string, current: number[], id: number, checked: boolean) {
            const set = new Set(current);
            if (checked) {
                set.add(id);
            } else {
                set.delete(id);
            }
            this.$emit(event, [...set].sort((a, b) => a - b));
        },
        emitAll() {
            this.$emit('selectDurations', DURATIONS.map((e) => e.id));
            this.$emit('selectTargets', TARGETS.map((e) => e.id));
        },
        emitNone() {
            this.$emit('selectDurations', []);
            this.$emit('selectTargets', []);
        },
    },
});
